import { render, staticRenderFns } from "./HotVideoItem.vue?vue&type=template&id=32b791c3"
import script from "./HotVideoItem.vue?vue&type=script&lang=js"
export * from "./HotVideoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports